import clsx from "clsx";
import React, {useState} from "react";
import AdminDashboardTwoColumnLayout from "../components/AdminDashboardTwoColumnLayout";
import TrendCard from "./TrendCard";
import PieChartCard from "./PieChartCard";
import DatePickerCard from "./DatePickerCard";
import turnoverAdult from "./JsonData/turnover-adult.json";
import turnoverChild from "./JsonData/turnover-child.json";
import ridesOverallAdult from "./JsonData/rides-overall-adult.json";
import ridesOverallChildren from "./JsonData/rides-overall-child.json";
import raceOccupancy from "./JsonData/race-occupancy.json";

const AdminStatisticsCalendar = () => {
    const date = new Date();
    const lastWeek = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 6);
    const [startDate, setStartDate] = useState(lastWeek);
    const [endDate, setEndDate] = useState(date);
    const [period, setPeriod] = useState(2);

    const PeriodTrendNormalized = (jsonData, name = "", color = "#000"): Record<string, unknown> => {
        const start = new Date(startDate);
        const end = new Date(endDate);
        const result = jsonData.filter(item => {
            const date = new Date(item.Date);
            return date >= start && date <= end;
        });
        //{Total:"1000", Date: "2020, 12, 01"}
        const dataFeed = {};
        const formattedResult = {};
        const days = {
            "0": "340", //sunday
            "1": "400",
            "2": "400",
            "3": "400",
            "4": "400",
            "5": "500",
            "6": "500", //saturday
        };

        result.map(item => {
            //get normalized value of race count per day
            formattedResult[item.Date.replaceAll(", ", "-")] = ((item.Total / days[item.Day]) * 100).toFixed(2);
        });
        console.log(formattedResult);
        dataFeed["name"] = name;
        dataFeed["color"] = color;
        dataFeed["data"] = formattedResult;
        return dataFeed;
    };

    const PeriodTrend = (jsonData, name = "", color = "#000") => {
        const start = new Date(startDate);
        const end = new Date(endDate);
        const result = jsonData.filter(item => {
            const date = new Date(item.Date);
            return date >= start && date <= end;
        });
        const dataFeed = {};
        const formattedResult = {};
        result.map(item => {
            formattedResult[item.Date.replaceAll(", ", "-")] = item.Total;
        });
        dataFeed["name"] = name;
        dataFeed["color"] = color;
        dataFeed["data"] = formattedResult;
        return dataFeed;
    };

    const PeriodCount = (jsonData, name = "", color = "#000") => {
        const start = new Date(startDate);
        const end = new Date(endDate);
        const result = jsonData.filter(item => {
            const date = new Date(item.Date);
            return date >= start && date <= end;
        });
        let dataFeed = {};
        let superTotal = 0;
        result.map(item => {
            superTotal += +item.Total;
        });
        dataFeed = [name, superTotal];
        console.log(dataFeed);
        return dataFeed;
    };
    return (
        <div className={clsx("AdminDashboard flex relative z-2 justify-evenly flex w-full h-full flex-col items-stretch ml-auto mr-auto")}>
            <AdminDashboardTwoColumnLayout
                contentLeft={
                    <div className="AdminStatisticsCalendar w-full flex-grow grid col-span-2 xl:grid-cols-2 gap-8 pr-8 overflow-y-auto max-h-full items-stretch justify-items-stretch">
                        <TrendCard
                            data={[PeriodTrend(turnoverAdult, "Karting Adult", "#33b0f0"), PeriodTrend(turnoverChild, "Karting Child", "#10ee35")]}
                            discrete={true}
                            legend={false}
                            stacked={false}
                            suffix={" CHF"}
                            title={"Period turnover"}
                        />

                        <TrendCard
                            data={[PeriodTrend(ridesOverallAdult, "Races over period", "#f00")]}
                            discrete={true}
                            legend={false}
                            stacked={false}
                            suffix={" Races"}
                            title={"Rides Overall"}
                        />
                        <PieChartCard
                            //data length = 2 - side by side
                            //data length > 2 - legend
                            center={"Rides driven"}
                            colors={["#333", "#f05841"]}
                            data={[PeriodCount(ridesOverallChildren, "children", "#f00"), PeriodCount(ridesOverallAdult, "adults", "#f00")]}
                            legend={false}
                            title={"Ride types"}
                        />

                        <TrendCard
                            data={[PeriodTrendNormalized(raceOccupancy, "Karting / hour", "#33b0f0")]}
                            discrete={true}
                            legend={false}
                            normalized={true}
                            stacked={false}
                            suffix={" %"}
                            title={"Race occupancy"}
                        />
                    </div>
                }
                contentRight={
                    <>
                        <DatePickerCard
                            endDate={endDate}
                            period={period}
                            setEndDate={setEndDate}
                            setPeriod={setPeriod}
                            setStartDate={setStartDate}
                            startDate={startDate}
                        />
                    </>
                }
            />
        </div>
    );
};

export default AdminStatisticsCalendar;
